export default __webpack_public_path__ + "static/media/craon16.7d26d7d3.jpg";